import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  createCustomPropType,
  isNumeric,
} from '../../../../js/app/react/validators';

import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import Tooltip from './../../../CommonComponents/Tooltip';
import {
  BACKEND_KEY,
  CHILDREN_CRUD_OVERVIEW,
  CHILDREN_CRUD_ADD_EDIT,
} from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import ChildrenAddEdit from '../../PersonalInfoWorkflow/Steps/ChildrenAddEditContainer';
import { isVisible } from '../../AdvWorkflow/AdvWorkflowHelpers';

const validateChildrenCRUD = (selectedChildFirstName, children) => () => {
  if (!children.find(child => child.FirstName === selectedChildFirstName)) {
    return ['Please select a child'];
  }
  return [];
};

class ChildrenCRUDView extends Component {
  componentDidUpdate({
    isPopulated: previousIsPopulated,
    branch: previousBranch,
    iterator: previousIterator,
  }) {
    const {
      clientId,
      workflowId,
      children,
      isPopulated,
      store2,
      fetchData,
      dirtyNodesMap,
      branch,
      iterator,
    } = this.props;

    if (!isVisible(previousBranch, previousIterator) && isVisible(branch, iterator)) {
      fetchData(workflowId, clientId, dirtyNodesMap);
    }

    if (!previousIsPopulated && isPopulated) {
      if (children.length === 1) {
        store2(workflowId)(
          {
            [BACKEND_KEY]: {
              SelectedChildFirstName: children[0].FirstName,
            },
          },
          clientId,
        );
      }
    }
  }

  render() {
    const {
      branch,
      workflowId,
      clientId,
      children,
      isEmptyState,
      store,
      store2,
      onAddChild,
      onEditChild,
      onRemoveChild,
      onPostSave,
      viewID,
      onSelectChild,
      selectedChildFirstName,
      nextIterators,
      educationGoals,
    } = this.props;

    return (
      <AdvWorkflowStep branch={branch} workflowId={workflowId} id="ChildrenCRUD">
        {viewID === CHILDREN_CRUD_OVERVIEW && (
          <div>
            <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.ChildrenCRUD`} />
            <h2>Which child&apos;s education are you saving for?</h2>
            <div className="adv-workflow-crud-widget">
              {isEmptyState ? (
                <div className="adv-workflow-crud-empty">
                  <div className="adv-workflow-crud-empty-add">
                    <button
                      className="adv-workflow-crud-empty-add-button"
                      type="button"
                      onClick={onAddChild(
                        children,
                        store(workflowId),
                        store2(workflowId),
                        clientId,
                        workflowId,
                        `${BACKEND_KEY}.ChildrenCRUD`,
                      )}
                    >
                      <i className="adv-workflow-crud-empty-add-button-i">+</i>
                      <br />
                      Add a new child
                    </button>
                  </div>
                </div>
              ) : (
                <div className="adv-workflow-crud-populated">
                  <ul className="adv-workflow-crud-populated-ul">
                    {children.map(({ FirstName, Age }, index) => (
                      <li className="adv-workflow-crud-populated-li">
                        <Tooltip
                          tag="button"
                          tooltipchildren={`Select ${FirstName} to fund their education`}
                          orientation="top"
                          className="adv-workflow-crud-populated-checkbox"
                          type="button"
                          aria-label="select child"
                          onClick={onSelectChild(
                            workflowId,
                            clientId,
                            educationGoals,
                            selectedChildFirstName,
                            FirstName,
                            `${BACKEND_KEY}.ChildrenCRUD`,
                          )}
                        >
                          {selectedChildFirstName === FirstName ? (
                            <i className="adv-workflow-crud-populated-checkbox-i fa fa-circle" />
                          ) : (
                            <i className="adv-workflow-crud-populated-checkbox-i-unselected fa" />
                          )}
                        </Tooltip>
                        <div className="adv-workflow-crud-populated-name-2">{FirstName}</div>
                        <div className="adv-workflow-crud-populated-value-2">{Age}</div>
                        <div className="adv-workflow-crud-populated-actions">
                          <button
                            type="button"
                            className="adv-workflow-crud-populated-action"
                            aria-label="edit child"
                            onClick={onEditChild(
                              children,
                              store(workflowId),
                              store2(workflowId),
                              index,
                              clientId,
                            )}
                          >
                            <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                          </button>
                          <button
                            type="button"
                            className="adv-workflow-crud-populated-action"
                            aria-label="remove child"
                            onClick={onRemoveChild(children, store(workflowId), index, clientId)}
                          >
                            <i className="adv-workflow-crud-populated-action-i far fa-trash-alt" />
                          </button>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <div className="adv-workflow-crud-populated-add">
                    <button
                      className="adv-workflow-crud-populated-add-button"
                      onClick={onAddChild(
                        children,
                        store(workflowId),
                        store2(workflowId),
                        clientId,
                        workflowId,
                        `${BACKEND_KEY}.ChildrenCRUD`,
                      )}
                      type="button"
                    >
                      <i className="adv-workflow-crud-populated-add-button-i">+</i>
                      Add a new child
                    </button>
                  </div>
                </div>
              )}
            </div>
            <Navigation
              nextIterators={nextIterators}
              dirtyGraphNodes={[]}
              validator={validateChildrenCRUD(selectedChildFirstName, children)}
              workflowId={workflowId}
              backendKey={BACKEND_KEY}
              validationId={`${BACKEND_KEY}.ChildrenCRUD`}
              onPostSave={onPostSave(store2(workflowId), clientId)}
              validatedOnClick={() =>
                workflowAnalyticsEvents(workflowId, 'children_info_completed')
              }
            />
          </div>
        )}
        {viewID === CHILDREN_CRUD_ADD_EDIT && <ChildrenAddEdit workflowId={workflowId} />}
      </AdvWorkflowStep>
    );
  }
}

ChildrenCRUDView.defaultProps = {
  selectedChildFirstName: null,
};

ChildrenCRUDView.propTypes = {
  nextIterators: PropTypes.arrayOf(PropTypes.string).isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store2: PropTypes.func.isRequired,
  isEmptyState: PropTypes.bool.isRequired,
  store: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(
    PropTypes.shape({
      FirstName: createCustomPropType(isNonEmptyString).isRequired,
      Age: createCustomPropType(isNumeric).isRequired,
    }),
  ).isRequired,
  onAddChild: PropTypes.func.isRequired,
  onEditChild: PropTypes.func.isRequired,
  onRemoveChild: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  viewID: PropTypes.oneOf([CHILDREN_CRUD_ADD_EDIT, CHILDREN_CRUD_OVERVIEW]).isRequired,
  onSelectChild: PropTypes.func.isRequired,
  selectedChildFirstName: PropTypes.string,
  isPopulated: PropTypes.bool.isRequired,
  educationGoals: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  fetchData: PropTypes.func.isRequired,
  dirtyNodesMap: PropTypes.shape({}).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default ChildrenCRUDView;
